import React, { useEffect, useState } from 'react';
import '../../styles/UGCourses.css';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import { FaBookOpen, FaFlask, FaLaptopCode } from 'react-icons/fa';

const UGCourses = () => {
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    setTimeout(() => setFadeIn(true), 100);
  }, []);

  const courses = [
    {
      title: 'Bachelor of Arts (B.A.)',
      icon: <FaBookOpen />,
      description:
        'A comprehensive program offering a blend of humanities, social sciences, and languages, fostering critical thinking and communication.',
    },
    {
      title: 'Bachelor of Science (B.Sc.)',
      icon: <FaFlask />,
      description:
        'Core science curriculum covering physics, chemistry, and mathematics with strong theoretical and practical foundations.',
    },
    {
      title: 'Bachelor of Science in Computer Science (B.Sc. CS)',
      icon: <FaLaptopCode />,
      description:
        'Industry-relevant program focusing on programming, data structures, web development, and modern computing technologies.',
    },
  ];

  return (
    <>
    <Navbar />
    <section className="section-wrapper">
    <div className={`academics-container ${fadeIn ? 'fade-in' : ''}`}>
      

      <section className="academics-header">
        <h4>SHRI MULIKADEVI MAHAVIDYALAYA, NIGHOJ</h4>
        <h2>Academics & Courses</h2>
        <p>
          Discover a wide range of undergraduate programs that empower students to grow intellectually and professionally.
        </p>
      </section>

      <section className="courses-section">
        {courses.map((course, index) => (
          <div className="course-card" key={index}>
            <div className="course-icon">{course.icon}</div>
            <h3>{course.title}</h3>
            <p>{course.description}</p>
          </div>
        ))}
      </section>

    </div>
    </section>
    <Footer />
    </>
  );
};

export default UGCourses;
